export type SeedSong = {
  kind: "take" | "file";
  label: string;
  seed: number;
  takeId?: string;
};

/** Stable RNG seed from a chosen song file. Music 3 has no ref_audio input. */
export async function seedFromAudioFile(file: File): Promise<SeedSong> {
  const buf = await file.arrayBuffer();
  const slice = buf.byteLength > 2 * 1024 * 1024 ? buf.slice(0, 2 * 1024 * 1024) : buf;
  const digest = await crypto.subtle.digest("SHA-256", slice);
  const seed = new DataView(digest).getUint32(0) % 1_000_000;
  const label = file.name.replace(/\.[^.]+$/, "").slice(0, 48) || "seed song";
  return { kind: "file", label, seed };
}
